export const isClaimMaker = (claim, reviewer) => (
  claim?.user?.id != null && reviewer?.id != null && String(claim.user.id) === String(reviewer.id)
);

export const validateClaimDecisionNote = note => {
  const normalized = String(note || '').trim();
  if (normalized.length < 3) return 'Enter a review note of at least 3 characters.';
  if (normalized.length > 2000) return 'Review note cannot exceed 2,000 characters.';
  return '';
};

export const evidenceSummary = evidence => {
  const value = evidence || {};
  return {
    note: value.note || 'No evidence note supplied',
    attested: value.attestation === true,
    source: value.source || 'Direct relationship claim',
    documentIds: Array.isArray(value.document_ids) ? value.document_ids : [],
  };
};
